import { render, staticRenderFns } from "./AddChargeScheme.vue?vue&type=template&id=84097cb2&scoped=true&"
import script from "./AddChargeScheme.vue?vue&type=script&lang=js&"
export * from "./AddChargeScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84097cb2",
  null
  
)

export default component.exports